/**
 * サイト URL の QR コード（TK-058。スクリーンショット経由の流入導線）。
 *
 * 内容: `HTTPS://JIGSAW.R18HAKADORU.AI`（英数字モード。ドメインは大文字小文字を
 * 区別しないため、より小さいシンボルになる大文字で符号化する）。
 * version 2（25 × 25 モジュール）/ 誤り訂正レベル L（冗長性最小）/ quiet zone 4 →
 * viewBox は 33 × 33。1 モジュール = 1 CSS px で表示する前提（board.css .qr-stamp）。
 *
 * 生成: `pnpm dlx qrcode -t svg -e L -m 4 "HTTPS://JIGSAW.R18HAKADORU.AI"` の出力から
 * XML 宣言と DOCTYPE を除いたもの。sharp でラスタライズ後 jsQR でデコードし、
 * 内容が一致することを確認済み（2026-08-20）。URL を変える場合は再生成・再検証する。
 */

/**
 * インライン挿入用の QR SVG（外形 33 × 33 モジュール、白地 + 黒モジュール）。
 *
 * 白地には `fill-opacity="0.57"` を付ける（TK-060）: コンテナの `opacity: 0.7` と合わせて
 * 白地の実効不透明度は約 40% になり、明るい写真の上でも下地が透けて「刻印」として馴染む
 * （白 70% を明るい地に重ねると混色がほぼ白になり、不透明にしか見えない）。黒モジュールは
 * 70% のままなので判読コントラストは保たれる。淡色写真・暗色・中間グレーの各背景に
 * 実効値で合成した状態で jsQR デコード検証済み（2026-08-20）。
 */
export const QR_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" shape-rendering="crispEdges"><path fill="#ffffff" fill-opacity="0.57" d="M0 0h33v33H0z"/><path stroke="#000000" d="M4 4.5h7m1 0h3m1 0h1m3 0h1m1 0h7M4 5.5h1m5 0h1m1 0h3m2 0h1m1 0h1m2 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h1m1 0h2m1 0h3m2 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m7 0h1m3 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m1 0h1m2 0h3m2 0h1m1 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M13 11.5h1m2 0h3m1 0h1M4 12.5h2m2 0h3m4 0h1m1 0h2m1 0h1m2 0h1m1 0h4M4 13.5h1m1 0h1m5 0h3m1 0h1m1 0h1m3 0h2m1 0h1M8 14.5h3m4 0h2m4 0h4m1 0h1M6 15.5h2m1 0h1m4 0h2m2 0h1m1 0h1m1 0h2m2 0h3M4 16.5h2m1 0h1m2 0h1m3 0h1m1 0h3m4 0h2M4 17.5h3m1 0h2m1 0h1m5 0h5m1 0h1m1 0h1M6 18.5h2m1 0h2m1 0h1m1 0h1m5 0h1m1 0h2m1 0h1m1 0h2M6 19.5h2m3 0h1m2 0h1m1 0h1m4 0h6M4 20.5h3m1 0h3m1 0h2m1 0h1m1 0h10m1 0h1M12 21.5h2m2 0h1m1 0h1m1 0h1m3 0h4M4 22.5h7m4 0h6m1 0h1m1 0h1m1 0h3M4 23.5h1m5 0h1m1 0h2m1 0h1m1 0h1m1 0h2m3 0h1m2 0h2M4 24.5h1m1 0h3m1 0h1m1 0h1m1 0h1m1 0h2m2 0h6m1 0h1M4 25.5h1m1 0h3m1 0h1m2 0h2m2 0h2m1 0h1m3 0h1m3 0h1M4 26.5h1m1 0h3m1 0h1m9 0h2m1 0h1m3 0h1M4 27.5h1m5 0h1m1 0h2m2 0h1m1 0h1m1 0h2m1 0h1m2 0h3M4 28.5h7m1 0h2m1 0h1m1 0h3m1 0h1m1 0h1m2 0h1m1 0h1"/></svg>';
